export enum CadastroConsumidorEnum {
  NAO_CADASTRADO = 'NAO_CADASTRADO',
  CADASTRADO_COM_SENHA = 'CADASTRADO_COM_SENHA',
  CADASTRADO_SEM_SENHA = 'CADASTRADO_SEM_SENHA',
}
